<!-- <mat-tab-group style="padding-bottom:10px;">
    <mat-tab label="INFO"> -->
        <div class="card-tab">
            <div class="layout-padding" fxLayout="column">
                <div style="margin-top: 15px;margin-bottom: 15px;">
                    <label style="font-size: 20px;font-weight: 600;">Detalles de la Empresa</label>
                </div>  
                <div style="text-align: right;"> 
                    <button 
                        mat-button
                        class="button-highlight"
                        type="button"
                        style="margin-right:10px;height: 35px;
                            padding: 0px 0px 0px 0px !important;"
                        (click)="fn_save()">
                        Grabar
                    </button>
                </div>
                <div
                  fxLayout="row wrap"
                  fxLayoutAlign="space-between center"
                  style="margin-left: 10px; margin-right: 10px;"
                > 
                    <mat-form-field fxFlex="30" fxFlex.md="30" fxFlex.xs="100">
                        <input type="text" name="companyName" matInput
                        #companyName="ngModel" [(ngModel)]="obj_Company.businessName"
                        placeholder="Nombre"
                        maxlength="30" required />
                        <mat-hint align="end">{{ companyName.value?.length || 0 }}/30</mat-hint>
                        <mat-error
                        *ngIf="companyName.errors && (companyName.touched || companyName.dirty)" >
                        Este campo es requerido
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field fxFlex="30" fxFlex.md="30" fxFlex.xs="100">
                        <input type="text" name="companyRuc" matInput
                        #companyRuc="ngModel" [(ngModel)]="obj_Company.ruc"
                        placeholder="RUC"
                        maxlength="11" required />
                        <mat-hint align="end">{{ companyRuc.value?.length || 0 }}/11</mat-hint>
                        <mat-error
                        *ngIf="companyRuc.errors && (companyRuc.touched || companyRuc.dirty)" >
                        Este campo es requerido
                        </mat-error>
                    </mat-form-field>
    
                    <mat-form-field fxFlex="30" fxFlex.md="30" fxFlex.xs="100">
                        <input type="text" name="companyEmail" matInput email
                        #companyEmail="ngModel" [(ngModel)]="obj_Company.eMail"
                        placeholder="Correo Electronico"
                        maxlength="50" required />
                        <mat-hint align="end">{{ companyEmail.value?.length || 0 }}/50</mat-hint>
                        <mat-error
                        *ngIf="companyEmail.errors && (companyEmail.touched || companyEmail.dirty)" >
                        Este campo es requerido
                        </mat-error>
                    </mat-form-field>
    
                    <mat-form-field fxFlex="30" fxFlex.md="30" fxFlex.xs="100">
                        <input type="text" name="companyIpress" matInput
                        #companyIpress="ngModel" [(ngModel)]="obj_Company.iPress"
                        placeholder="IPRESS" maxlength="30" required />
                        <mat-hint align="end">{{ companyIpress.value?.length || 0 }}/50</mat-hint>
                        <mat-error
                        *ngIf="companyIpress.errors && (companyIpress.touched || companyIpress.dirty)" >
                        Este campo es requerido
                        </mat-error>
                    </mat-form-field>
    
                    <mat-form-field fxFlex="30" fxFlex.md="30" fxFlex.xs="100">
                        <input type="text" name="companyUgipress" matInput
                        #companyUgipress="ngModel" [(ngModel)]="obj_Company.ugiPress"
                        placeholder="UGIPRESS" maxlength="30" required />
                        <mat-hint align="end">{{ companyUgipress.value?.length || 0 }}/50</mat-hint>
                        <mat-error
                        *ngIf="companyUgipress.errors && (companyUgipress.touched || companyUgipress.dirty)" >
                        Este campo es requerido
                        </mat-error>
                    </mat-form-field>
                    
                    <mat-form-field fxFlex="30" fxFlex.md="30" fxFlex.xs="100">
                        <input type="text" name="companyPhone" matInput
                        #companyPhone="ngModel" [(ngModel)]="obj_Company.phone"
                        placeholder="Telefono" maxlength="30" required />
                        <mat-hint align="end">{{ companyPhone.value?.length || 0 }}/50</mat-hint>
                        <mat-error
                        *ngIf="companyPhone.errors && (companyPhone.touched || companyPhone.dirty)" >
                        Este campo es requerido
                        </mat-error>
                    </mat-form-field>
    
                    <mat-form-field fxFlex="30" fxFlex.md="30" fxFlex.xs="100">
                        <input type="text" name="companyAddress" matInput
                        #companyAddress="ngModel" [(ngModel)]="obj_Company.address"
                        placeholder="Direccion" maxlength="30" required />
                        <mat-hint align="end">{{ companyAddress.value?.length || 0 }}/100</mat-hint>
                        <mat-error
                        *ngIf="companyAddress.errors && (companyAddress.touched || companyAddress.dirty)" >
                        Este campo es requerido
                        </mat-error>
                    </mat-form-field>
     
                </div>
            </div>
            <div class="layout-padding" fxLayout="column" style="width: 100%;">
                <div style="margin-top: 15px;margin-bottom: 15px;">
                    <label style="font-size: 20px;font-weight: 600;">Logo</label>
                </div>  
                <app-company-logo [vc_idCompany]="vc_idCompanyUser"></app-company-logo>
            </div>
            <div class="layout-padding" fxLayout="column" style="width: 100%;">
                <!-- <label>Locales</label> -->
                <div style="margin-top: 15px;margin-bottom: 15px;">
                    <label style="font-size: 20px;font-weight: 600;">Locales</label>
                </div>
                <div class="card-grid">
                    <mat-card class="mat-card" 
                        *ngFor="let item of oc_localsCompany" (mouseover)="vc_hoverElement = item" (mouseleave)="vc_hoverElement = null">
                        <mat-card-header class="mat-card-header">
                            <mat-card-title class="mat-card-title">
                                <div class="mat-card-title-text">
                                    <p style="cursor: pointer;" (click)="fn_AddLocal(item)">{{item.nameLocal}} </p>
                                    <mat-icon [ngClass]="vc_hoverElement === item ? 'show-icon' : 'hide-icon'" *ngIf="item.nameLocal != '+ Agregar'"
                                        (click)="fn_deleteLocal(item.idLocal, item.nameLocal)">close</mat-icon>
                                    <mat-icon *ngIf="item.nameLocal == '+ Agregar'"></mat-icon> 
                                </div>
                            </mat-card-title>
                        </mat-card-header>    
                        <mat-card-actions class="mat-card-content">
                            <p>{{item.addressLocal}}</p>
                            <p>{{item.nameDistrict}}</p>
                            <p>{{item.phoneLocal}}</p>
                        </mat-card-actions>                                  
                    </mat-card>
                </div>
            </div>
        </div>
    <!-- </mat-tab>
    <mat-tab label="SEGURIDAD">
        <div class="layout-padding" fxLayout="column">
            <app-password-reset></app-password-reset>
        </div>
    </mat-tab>
</mat-tab-group> -->